/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthLog } from './auth-log.model';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe, JsonPipe, NgStyle } from '@angular/common';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'auth-shared-auth-logs',
  templateUrl: './shared-auth-logs.component.html',
  styleUrls: ['./shared-auth-logs.component.scss'],
  standalone: true,
  imports: [TableModule, TranslateModule, NgStyle, SharedComponentsModule, DatePipe, InputTextModule, JsonPipe],
})
export class SharedAuthLogsComponent {
  @Input() authLogs: AuthLog[] | undefined = undefined;
  @Input() totalRecords = 10;
  @Input() sortField = 'loginDate';
  @Output() lazyLoad: EventEmitter<any> = new EventEmitter<any>(true);
}
